import { type NuxtAxiosInstance } from '@/types/axios'

import { ResponseCode, type ResultGenericVM } from '@/view-models/common'
import type { TagDetail } from '@/types/api'

export async function getTagDetail(axios: NuxtAxiosInstance, tagId: number | string) {
  if (!tagId) {
    throw new Error('tag id cant be empty')
  }

  const res = await axios.$get<ResultGenericVM<TagDetail>>(`/pub/tag/${tagId}`)

  if (res.code !== ResponseCode.Success) {
    throw res
  }

  return res
}
